export const allSounds = [
    '/sounds/3_2_1.wav',
    '/sounds/buy.mp3',
    '/sounds/buy2.mp3',
    '/sounds/hover.mp3',
    '/sounds/hover3.mp3',
    '/sounds/hover4.mp3',
    '/sounds/message_sent.mp3',
    '/sounds/open_case.mp3',
    '/sounds/open_chat.mp3',
    '/sounds/race_peep.mp3',
    '/sounds/research.mp3',
    '/sounds/scrap.mp3',
    '/sounds/tick.mp3',
    '/sounds/win.mp3',
    '/sounds/points_count.mp3',
    '/sounds/menu_sound_1.wav',
    '/sounds/woosh_1.wav',
    '/sounds/woosh_1_reversed.wav'
];

